export default [
  {
    id: 4,
    user_id: 5,
    name: "کمپین بنری روز مرد ۱۴۰۰",
    category: "گروه بنری روز مرد ۱۴۰۰",
    status: "تمام شده",
    count_position: 14,
    count_view_each_hour: 15,
    price_each_day: 45550,
    max_time_duration_banner: 7,
    site_publisher: [
      {
        url: "https://rullplug.ir",
        count_view_each_hour: 9,
      },
      {
        url: "https://www.fiorigroup.ir",
        count_view_each_hour: 6,
      },
    ],
    positions: [
      {
        tagHtmlID: "hilite-position-1624",
        count_view_each_hour: 1,
      },
      {
        tagHtmlID: "hilite-position-1623",
        count_view_each_hour: 1,
      },
      {
        tagHtmlID: "hilite-position-1625",
        count_view_each_hour: 1,
      },
      {
        tagHtmlID: "hilite-position-1627",
        count_view_each_hour: 1,
      },
      {
        tagHtmlID: "hilite-position-1626",
        count_view_each_hour: 1,
      },
      {
        tagHtmlID: "hilite-position-1632",
        count_view_each_hour: 1,
      },
      {
        tagHtmlID: "hilite-position-1633",
        count_view_each_hour: 1,
      },
      {
        tagHtmlID: "hilite-position-1634",
        count_view_each_hour: 1,
      },
      {
        tagHtmlID: "hilite-position-619",
        count_view_each_hour: 2,
      },
      {
        tagHtmlID: "hilite-position-634",
        count_view_each_hour: 1,
      },
      {
        tagHtmlID: "hilite-position-628",
        count_view_each_hour: 1,
      },
      {
        tagHtmlID: "hilite-position-635",
        count_view_each_hour: 1,
      },
      {
        tagHtmlID: "hilite-position-645",
        count_view_each_hour: 1,
      },
      {
        tagHtmlID: "hilite-position-642",
        count_view_each_hour: 1,
      },
    ],
    browsers: {
      browsers_OS: {
        "Mac OS": 0,
        iOS: 4555,
        Windows: 13665,
        Android: 25052,
        Linux: 2277,
      },
      browsers_type: {
        chrome: 38717,
        firefox: 2277,
        safari: 4555,
      },
    },
  },
  {
    id: 3,
    user_id: 4,
    name: "کمپین بنری روز زن ۱۴۰۰",
    category: "گروه بنری روز زن ۱۴۰۰",
    status: "تمام شده",
    count_position: 18,
    count_view_each_hour: 20,
    price_each_day: 67500,
    max_time_duration_banner: 13,
    site_publisher: [
      {
        url: "https://bestig.ir",
        count_view_each_hour: 16,
      },
      {
        url: "https://jobs-info.ir",
        count_view_each_hour: 2,
      },
      {
        url: "https://eimeni.ir",
        count_view_each_hour: 2,
      },
    ],
    positions: [
      {
        tagHtmlID: "hilite-position-331",
        count_view_each_hour: 1,
      },
      {
        tagHtmlID: "hilite-position-308",
        count_view_each_hour: 1,
      },
      {
        tagHtmlID: "hilite-position-310",
        count_view_each_hour: 1,
      },
      {
        tagHtmlID: "hilite-position-311",
        count_view_each_hour: 1,
      },
      {
        tagHtmlID: "hilite-position-1920",
        count_view_each_hour: 1,
      },
      {
        tagHtmlID: "hilite-position-1919",
        count_view_each_hour: 1,
      },
      {
        tagHtmlID: "hilite-position-1918",
        count_view_each_hour: 1,
      },
      {
        tagHtmlID: "hilite-position-1923",
        count_view_each_hour: 1,
      },
      {
        tagHtmlID: "hilite-position-1922",
        count_view_each_hour: 1,
      },
      {
        tagHtmlID: "hilite-position-1927",
        count_view_each_hour: 1,
      },
      {
        tagHtmlID: "hilite-position-1926",
        count_view_each_hour: 1,
      },
      {
        tagHtmlID: "hilite-position-1321",
        count_view_each_hour: 1,
      },
      {
        tagHtmlID: "hilite-position-1323",
        count_view_each_hour: 1,
      },
      {
        tagHtmlID: "hilite-position-1324",
        count_view_each_hour: 2,
      },
      {
        tagHtmlID: "hilite-position-1328",
        count_view_each_hour: 1,
      },
      {
        tagHtmlID: "hilite-position-1327",
        count_view_each_hour: 2,
      },
      {
        tagHtmlID: "hilite-position-1332",
        count_view_each_hour: 1,
      },
      {
        tagHtmlID: "hilite-position-1331",
        count_view_each_hour: 1,
      },
    ],
    browsers: {
      browsers_OS: {
        "Mac OS": 0,
        iOS: 13500,
        Windows: 20250,
        Android: 27000,
        Linux: 6750,
      },
      browsers_type: {
        chrome: 47250,
        firefox: 6750,
        safari: 13500,
      },
    },
  },
  {
    id: 2,
    user_id: 4,
    name: "کمپین بنری عید فطر ۱۴۰۰",
    category: "گروه بنری عید فطر ۱۴۰۰",
    status: "تمام شده",
    count_position: 16,
    count_view_each_hour: 18,
    price_each_day: 40500,
    max_time_duration_banner: 10,
    site_publisher: [
      {
        url: "https://monirlock.ir",
        count_view_each_hour: 10,
      },
      {
        url: "https://www.ezcurra.ir",
        count_view_each_hour: 6,
      },
      {
        url: "https://sista.ir",
        count_view_each_hour: 2,
      },
    ],
    positions: [
      {
        tagHtmlID: "hilite-position-1268",
        count_view_each_hour: 1,
      },
      {
        tagHtmlID: "hilite-position-1269",
        count_view_each_hour: 1,
      },
      {
        tagHtmlID: "hilite-position-1270",
        count_view_each_hour: 1,
      },
      {
        tagHtmlID: "hilite-position-1274",
        count_view_each_hour: 1,
      },
      {
        tagHtmlID: "hilite-position-1273",
        count_view_each_hour: 1,
      },
      {
        tagHtmlID: "hilite-position-375",
        count_view_each_hour: 1,
      },
      {
        tagHtmlID: "hilite-position-376",
        count_view_each_hour: 1,
      },
      {
        tagHtmlID: "hilite-position-374",
        count_view_each_hour: 1,
      },
      {
        tagHtmlID: "hilite-position-372",
        count_view_each_hour: 1,
      },
      {
        tagHtmlID: "hilite-position-371",
        count_view_each_hour: 1,
      },
      {
        tagHtmlID: "hilite-position-2",
        count_view_each_hour: 2,
      },
      {
        tagHtmlID: "hilite-position-7",
        count_view_each_hour: 1,
      },
      {
        tagHtmlID: "hilite-position-337",
        count_view_each_hour: 1,
      },
      {
        tagHtmlID: "hilite-position-17",
        count_view_each_hour: 1,
      },
      {
        tagHtmlID: "hilite-position-18",
        count_view_each_hour: 2,
      },
      {
        tagHtmlID: "hilite-position-19",
        count_view_each_hour: 1,
      },
    ],
    browsers: {
      browsers_OS: {
        "Mac OS": 0,
        iOS: 2025,
        Windows: 4050,
        Android: 32400,
        Linux: 2025,
      },
      browsers_type: {
        chrome: 36450,
        firefox: 2025,
        safari: 2025,
      },
    },
  },
  {
    id: 1,
    user_id: 4,
    name: "کمپین بنری عید نوروز ۱۴۰۰",
    category: "گروه بنری عید نوروز ۱۴۰۰",
    status: "تمام شده",
    count_position: 13,
    count_view_each_hour: 15,
    price_each_day: 594500,
    max_time_duration_banner: 8,
    site_publisher: [
      {
        url: "https://jobs-info.ir",
        count_view_each_hour: 9,
      },
      {
        url: "https://senfnews.com",
        count_view_each_hour: 2,
      },
      {
        url: "https://solga.ir",
        count_view_each_hour: 4,
      },
    ],
    positions: [
      {
        tagHtmlID: "hilite-position-1922",
        count_view_each_hour: 1,
      },
      {
        tagHtmlID: "hilite-position-1923",
        count_view_each_hour: 1,
      },
      {
        tagHtmlID: "hilite-position-1925",
        count_view_each_hour: 2,
      },
      {
        tagHtmlID: "hilite-position-1698",
        count_view_each_hour: 1,
      },
      {
        tagHtmlID: "hilite-position-1699",
        count_view_each_hour: 1,
      },
      {
        tagHtmlID: "hilite-position-1700",
        count_view_each_hour: 2,
      },
      {
        tagHtmlID: "hilite-position-1703",
        count_view_each_hour: 1,
      },
      {
        tagHtmlID: "hilite-position-1704",
        count_view_each_hour: 1,
      },
      {
        tagHtmlID: "hilite-position-1054",
        count_view_each_hour: 1,
      },
      {
        tagHtmlID: "hilite-position-1056",
        count_view_each_hour: 1,
      },
      {
        tagHtmlID: "hilite-position-1057",
        count_view_each_hour: 1,
      },
      {
        tagHtmlID: "hilite-position-1065",
        count_view_each_hour: 1,
      },
      {
        tagHtmlID: "hilite-position-1064",
        count_view_each_hour: 1,
      },
    ],
    browsers: {
      browsers_OS: {
        "Mac OS": 0,
        iOS: 41615,
        Windows: 178350,
        Android: 356700,
        Linux: 17835,
      },
      browsers_type: {
        chrome: 535050,
        firefox: 17835,
        safari: 41615,
      },
    },
  },
];
